let navigationDrawer = null;
try {
  const raw = localStorage.getItem("navigationDrawer");
  navigationDrawer = raw ? JSON.parse(raw) : null;
} catch (e) {
  navigationDrawer = null;
}


export default {
  navigationDrawer,
};
